import { render, staticRenderFns } from "./NewsContentHome.vue?vue&type=template&id=6e468338&scoped=true"
import script from "./NewsContentHome.vue?vue&type=script&lang=js"
export * from "./NewsContentHome.vue?vue&type=script&lang=js"
import style0 from "./NewsContentHome.vue?vue&type=style&index=0&id=6e468338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e468338",
  null
  
)

export default component.exports